import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import { typo } from "../../../assets/fonts/font";
import useSWR from "swr";
import { generalItemFetcher } from "../../../helpers/Fetchers/fetchers";
import { PATH_NAME } from "../../../configs/pathName";
import { IBanner, IBannerItems } from "../../../models/IBanner";
import colorConfigs from "../../../configs/colorConfigs";

const scrollAnimation = keyframes`
  0% {
    transform: translateX(0); /* Start at the initial position */
  }
  100% {
    transform: translateX(-50%); /* Scroll halfway to allow seamless looping */
  }
`;

const AnnouncementSlide: React.FC = () => {
  const { data: banners }: { data: IBanner[] } = useSWR(PATH_NAME.API_ASSETS, generalItemFetcher);

  const [announcementItems, setAnnouncementItems] = useState<IBannerItems[]>([]);

  useEffect(() => {
    if (banners && banners.length > 0) {
      const announcement = banners.find(
        (banner) => banner.placement === "announcement"
      );
      if (announcement && announcement.items) {
        const repeatedAnnouncements = [
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
          ...announcement.items,
        ];
        setAnnouncementItems(repeatedAnnouncements);
      }
    }
  }, [banners]);

  return (
    <Box
      sx={{
        overflow: "hidden",
        backgroundColor: "var(--color-black)",
        color: "var(--color-white)",
        padding: "8px 0",
        width: "100%",
        height: "40px",
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          whiteSpace: "nowrap",
          animation: `${scrollAnimation} 80s linear infinite`,
        }}
      >
        {announcementItems.map((item, index) => (
          <Typography
            key={index}
            sx={{
              display: "inline-block",
              marginRight: "150px",
              width: "50%",
              ...typo.bodyContent,
              color: colorConfigs.secondary,
            }}
          >
            {item.text}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default AnnouncementSlide;